import React from 'react';
import classNames from 'classnames';
import { useDispatch } from 'react-redux';
import {
  Button,
  Image,
} from '@uncinc/uncinc-react-kitchen-sink';
import { WysiwygField } from '../../../components';
import { trackEvent } from '../../../actions/UI';


import './style.scss';

const COLOR_YELLOW = 'yellow';
const COLOR_BLUE = 'blue';

const Cta = ({ entity, mode }) => {
  const title = entity.getIn(['field_title', 0, 'value'], '');
  const reversed = entity.getIn(['field_flipped', 0, 'value'], false);
  const body = entity.getIn(['field_body_cta', 0, 'processed'], entity.getIn(['body', 0, 'processed'], ''));
  const linkHref = entity.getIn(['field_link', 0, 'alias'], entity.getIn(['field_link', 0, 'uri']));
  const linkTitle = entity.getIn(['field_link', 0, 'title']);
  const image = entity.getIn(['field_image', 0, 'styles', 'teaser_square'], null);
  const backgroundColor = entity.getIn(['field_background_color', 0, 'value'], COLOR_BLUE);

  const dispatch = useDispatch();

  const onCtaClick = () => {
    if (linkTitle && linkTitle.includes('starterspakket')) {
      dispatch(trackEvent('Starterpakket', 'Klik op "Bestel het starterspakket" knop', 'Starterpakket', null));
    } else {
      dispatch(trackEvent('CTA', `Klik op "${linkTitle}" knop naar "${linkHref}" toe`, 'CTA', linkTitle));
    }
  };

  const classes = classNames('Cta', [
    reversed ? 'reversed' : null,
    mode,
  ]);
  const containerClasses = classNames([
    mode === 'small' ? 'container container--small' : null,
    `type-${backgroundColor}`,
  ]);

  return (
    <div className={containerClasses}>
      <div className={classes}>
        <div className="Cta__content">
          <div className="Cta__contentWrapper">
            <div className="row">
              {/* Optional image */}
              {image && (
                <div className="col-12 col-md-4 col-lg-5 Cta__contentWrapper__image">
                  <Image
                    lazyload={false}
                    src={image}
                    className="Cta__image"
                  />
                </div>
              )}
              <div className={`col-sm-12 ${image ? 'col-md-8 col-lg-7' : 'col-lg-7'}`}>
                <h2 className="Cta__title">{title}</h2>
                <WysiwygField
                  property="schema:text"
                  className="Cta__body"
                  html={body}
                />
                {linkHref && linkTitle && (
                  <Button
                    onClick={onCtaClick}
                    className="Cta__button Button--secondary"
                    href={linkHref}>
                    {linkTitle}
                  </Button>
                )}
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default Cta;
